import { reduceStatuses } from "shared-ui/MenuOrder/status";
import { KdsPageMealMenuPlateOrderPreviewFragment, useKdsTicketsMealMenuPlateOrderQuery } from "../../../types";
import { WebPrinterTicketOrder } from "../types";
import { getMenuOrderUpdatedAt } from "../utils";
import { BaseKdsTicket } from "./BaseKdsTicket";
import { convertToOrderWithDiningStationItems } from "./utils";

interface PlateOrderKDSTicketProps {
  menuOrderItemIdsToDiningStationName: Record<string, string>;
  diningStationIds: string[];
  orderPreview: KdsPageMealMenuPlateOrderPreviewFragment;
  setSelectedWebPrinterTicketOrder: (o: WebPrinterTicketOrder) => void;
  inBulkSelect: boolean;
  selectForBulkSelect: (orderId: string, value: boolean) => void;
  isSelected: boolean;
}
export const PlateOrderKDSTicket = ({
  orderPreview,
  diningStationIds,
  menuOrderItemIdsToDiningStationName,
  setSelectedWebPrinterTicketOrder,
  inBulkSelect,
  selectForBulkSelect,
  isSelected,
}: PlateOrderKDSTicketProps) => {
  const orderStatus = reduceStatuses(orderPreview.itemsByDiningStation.map(i => i.status));
  //const [runQuery, {data, loading}] = useKdsTicketsMenuOrderLazyQuery({
  const { data, loading } = useKdsTicketsMealMenuPlateOrderQuery({
    variables: { mealMenuPlateOrderId: orderPreview.id, diningStationIds },
    //fetchPolicy: 'network-only'
    // TODO: We are going to be issuing too many requests if we set this to network-only
    // ...there is an off-chance that when a ticket is re-rendered it has stale choices,
    // but we are relying on the `subscription` to handle updates. This is a compromise.
  });
  const menuOrderWithItems =
    data && data.mealMenuPlateOrder
      ? convertToOrderWithDiningStationItems({
          order: data.mealMenuPlateOrder,
          menuOrderItemIdsToDiningStationName,
        })
      : null;

  const menuOrderUpdatedAt = data && getMenuOrderUpdatedAt(data.mealMenuPlateOrder);
  return (
    <BaseKdsTicket
      athlete={data?.mealMenuPlateOrder.athlete}
      orderStatus={orderStatus}
      orderPreview={orderPreview}
      setSelectedWebPrinterTicketOrder={setSelectedWebPrinterTicketOrder}
      inBulkSelect={inBulkSelect}
      selectForBulkSelect={selectForBulkSelect}
      isSelected={isSelected}
      menuOrderUpdatedAt={menuOrderUpdatedAt}
      orderWithItems={menuOrderWithItems}
      loading={loading}
      bulkOrderCode={data?.mealMenuPlateOrder.parentBulkOrder.code ?? null}
    />
  );
};

export default PlateOrderKDSTicket;
